import PropertyScreen from './PropertyScreen';

export default PropertyScreen;
